var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('alerts-form',{on:{"notification-sent":function($event){return _vm.onNotificationSent()}}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('alerts-table',{ref:"alertsTable"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f065bd4","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Customer/Alerts.vue
// module id = 1895
// module chunks = 0